import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

interface ToastState {
  message: string;
  tone: 'success' | 'danger';
}

const ToastContext = createContext<(message: string, tone?: ToastState['tone']) => void>(
  () => undefined,
);

export function useToast() {
  return useContext(ToastContext);
}

/** Sağ altta 3 saniye görünen bildirim (§1.7). */
export function ToastProvider({ children }: { children: ReactNode }) {
  const [toast, setToast] = useState<ToastState | null>(null);

  const show = useCallback((message: string, tone: ToastState['tone'] = 'success') => {
    setToast({ message, tone });
    setTimeout(() => setToast(null), 3000);
  }, []);

  const value = useMemo(() => show, [show]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      {toast && (
        <div
          role="status"
          style={{
            position: 'fixed',
            right: 28,
            bottom: 28,
            background: 'var(--surface)',
            borderLeft: `4px solid ${toast.tone === 'success' ? 'var(--success)' : 'var(--danger)'}`,
            borderRadius: 'var(--r-menu)',
            padding: '14px 18px',
            boxShadow: '0 6px 24px rgba(16,30,56,.12)',
            fontWeight: 500,
            fontSize: 14,
            animation: 'toast-in .22s ease-out',
            zIndex: 40,
            maxWidth: 420,
          }}
        >
          {toast.message}
        </div>
      )}
    </ToastContext.Provider>
  );
}
